import Focusable from "./focusable.js";

const _TAB_KEY = 'Tab';
const _ESCAPE_KEY = 'Escape';

export function trapFocus(element) {
	if (!element) return;

	const focusable = Focusable(element);

	const evHandlers = {
		keepFocus: (e) => keepFocus(e),
		keyPress: (e) => onKeypress(e)
	}

	const getFocusableChildren = () => {
		const excludedSlots = element?.getExcludedSlots?.() || [];
		const focusableBefore = element?.getFocusableBefore?.() || [];
		const focusableAfter = element?.getFocusableAfter?.() || [];
		return ([...focusableBefore, ...focusable.keyboardOnly, ...focusableAfter]).filter((child) => !!(
			!excludedSlots?.includes(child.getAttribute('slot')) &&
			(child.offsetWidth ||
				child.offsetHeight ||
				child.getClientRects().length)
		));
	}

	const setFocusToFirstItem = () => {
		const focusableChildren = getFocusableChildren();
		const focused = element.querySelector('[autofocus]') || focusableChildren[0];

		if (focused) {
			focused.focus();
		}
	}

	const onKeypress = (event) => {
		// If the dialog is shown and the ESCAPE key is being pressed, prevent any
		// further effects from the ESCAPE key and hide the dialog, unless its role
		// is 'alertdialog', which should be modal
		if (event.key === _ESCAPE_KEY && ((event.target.matches('input[type="search"]') && event.target.value) || (!event.target.matches('[role="switch"]') && event.target.value) || (!event.target.matches('[role="combobox"]') && event.target.value))) {
			event.preventDefault();
		}

		// If the dialog is shown and the TAB key is being pressed, make sure the
		// focus stays trapped within the dialog element
		if (event.key === _TAB_KEY) {
			trapTabKey(event);
		}
	}

	const trapTabKey = (event) => {
		const focusableChildren = getFocusableChildren();
		let activeElement = document.activeElement
		if (activeElement === element) {
			activeElement = focusableChildren[0];
		}
		const focusedItemIndex = focusableChildren.indexOf(activeElement);

		if (focusableChildren.length === 1) {
			focusableChildren[0].focus();
			event.preventDefault();
		} else {

			// If the SHIFT key is being pressed while tabbing (moving backwards) and
			// the currently focused item is the first one, move the focus to the last
			// focusable item from the dialog element
			if (event.shiftKey && focusedItemIndex === 0) {
				focusableChildren[focusableChildren.length - 1].focus();
				event.preventDefault();
				// If the SHIFT key is not being pressed (moving forwards) and the currently
				// focused item is the last one, move the focus to the first focusable item
				// from the dialog element
			} else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
				focusableChildren[0].focus();
				event.preventDefault();
			}
		}
	}

	const keepFocus = (event) => {
		// If the dialog is shown and the focus is not within the dialog element,
		// move it back to its first focusable child
		if (!element.contains(event.target)) {
			setFocusToFirstItem();
		}
	}

	return {
		setFocusToFirstItem,
		evHandlers
	};
}
